import { render, staticRenderFns } from "./consent-register-api-instructions-dialog.vue?vue&type=template&id=64fd7f06&scoped=true&"
import script from "./consent-register-api-instructions-dialog.vue?vue&type=script&lang=js&"
export * from "./consent-register-api-instructions-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fd7f06",
  null
  
)

export default component.exports